import { render, staticRenderFns } from "./ubicacion.vue?vue&type=template&id=bc125ba8&scoped=true&"
import script from "./ubicacion.vue?vue&type=script&lang=ts&"
export * from "./ubicacion.vue?vue&type=script&lang=ts&"
import style0 from "./ubicacion.vue?vue&type=style&index=0&id=bc125ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc125ba8",
  null
  
)

export default component.exports